/* Media cards: inline player (one panel per [data-mrow]) + prev/next arrows for [data-rail-track].
   Shared by sections/media-rows.liquid and sections/media-grid.liquid; loaded deferred from the layout. */
(() => {
  if (window.__dnaMediaPlayer) return;
  window.__dnaMediaPlayer = true;
  const rows = document.querySelectorAll('[data-mrow]');
  if (!rows.length) return;
  const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const toggles = document.querySelectorAll('[data-media-toggle]');

  // Close every player and drop its iframe — a hidden iframe would keep playing audio.
  const closeAll = () => {
    document.querySelectorAll('[data-player]').forEach((panel) => {
      panel.hidden = true;
      const frame = panel.querySelector('[data-frame]');
      if (frame) frame.replaceChildren();
    });
    toggles.forEach((b) => b.setAttribute('aria-expanded', 'false'));
  };

  toggles.forEach((btn) => {
    btn.addEventListener('click', () => {
      const row = btn.closest('[data-mrow]');
      const panel = row && row.querySelector('[data-player]');
      const frame = panel && panel.querySelector('[data-frame]');
      if (!frame) return;
      const wasOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAll();
      if (wasOpen) return;
      const f = document.createElement('iframe');
      f.src = btn.dataset.embed;
      f.title = btn.dataset.title || 'Video';
      f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen *;');
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('scrolling', 'no');
      frame.appendChild(f);
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      panel.scrollIntoView({ block: 'nearest', behavior });
    });
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  rows.forEach((row) => {
    const track = row.querySelector('[data-rail-track]');
    const nav = row.querySelector('[data-rail-nav]');
    if (!track || !nav) return;
    const prev = nav.querySelector('[data-rail-prev]');
    const next = nav.querySelector('[data-rail-next]');
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const overflows = max > 4;
      nav.hidden = !overflows;
      if (!overflows) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior });
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else addEventListener('resize', update);
    update();
  });
})();
